import { Box } from '@tempmee/react';
import { borderRadius, shadows } from '@tempmee/tailwind';

type DashboardCardProps = React.HTMLAttributes<HTMLDivElement>;

export const DashboardCard = ({ children, style, ...rest }: DashboardCardProps) => (
  <Box
    style={{ borderRadius: borderRadius.pill, boxShadow: shadows['elevation-4'], overflow: 'hidden', ...style }}
    {...rest}
  >
    {children}
  </Box>
);
